import { createGlobalStyle } from 'styled-components';

import { darkDynamicColors } from './theme';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    outline: 0;
    padding: 0;
    font-family: 'Roboto';
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  html, body, #__next {
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    background-color: ${darkDynamicColors.neutral950};
  }

  button {
    border: none;
    background: none;
    font-weight: bold;
    cursor: pointer;
  }

  #__next {
    z-index: 0;
    > main {
      height: 100%;
    }
  }

  a {
    text-decoration: none;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${darkDynamicColors.neutral950};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${darkDynamicColors.primary};
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${darkDynamicColors.primary};
    filter: brightness(0.85);
  }

  html {
    scrollbar-width: thin;
    scrollbar-color: ${darkDynamicColors.primary} ${darkDynamicColors.neutral950};
  }

  #portal-root {
    overflow: hidden;
  }
`;
